// src/state/app/types.ts
var SET_NETWORK_STATUS = "SET_NETWORK_STATUS";
var SET_SHOW_TOAST = "SET_SHOW_TOAST";
var SET_LOCK_SCREEN_BANNER = "SET_LOCK_SCREEN_BANNER";
var UPDATE_POPOVER = "UPDATE_POPOVER";
var SET_HIDE_TOAST = "SET_HIDE_TOAST";
var REMOVE_TOAST_ELEMENT = "REMOVE_TOAST_ELEMENT";
var SET_SHOW_REFRESH_TOAST = "SET_SHOW_REFRESH_TOAST";
var SET_SHOW_SETTINGS_REFRESH_TOAST = "SET_SHOW_SETTINGS_REFRESH_TOAST";
var SET_HIDE_REFRESH_TOAST = "SET_HIDE_REFRESH_TOAST";
var SET_SELECTED_NETWORK = "SET_SELECTED_NETWORK";
var SET_PULLING_DATA = "SET_PULLING_DATA";
var SET_CURRENT_DEVICE_USING_LICENSE = "SET_CURRENT_DEVICE_USING_LICENSE";
var SET_IS_LOADING = "SET_IS_LOADING";
var SET_IS_LOADING_MORE = "SET_IS_LOADING_MORE";
var SET_SHOW_CONFORMATION_MODAL = "SET_SHOW_CONFORMATION_MODAL";
var SET_SHOW_CONFIRMATION_MODAL_QUEUE = "SET_SHOW_CONFIRMATION_MODAL_QUEUE";
var SET_IS_LOADING_MODAL = "SET_IS_LOADING_MODAL";
var SET_MESSAGE_ID = "SET_MESSAGE_ID";
var UPDATE_PRINTER_STATUS = "UPDATE_PRINTER_STATUS";
var KITCHEN_PRINTING_ERROR = "KITCHEN_PRINTING_ERROR";
var KITCHEN_PRINTING_ERROR_WS = "KITCHEN_PRINTING_ERROR_WS";
var TRANSFERRED_PRINT_JOBS = "TRANSFERRED_PRINT_JOBS";
var CONFIRMED_PRINT_JOBS = "CONFIRMED_PRINT_JOBS";
var FIRE_PRINTING_ERROR = "FIRE_PRINTING_ERROR";
var CLEAR_FIRE_PRINTING_ERROR = "CLEAR_FIRE_PRINTING_ERROR";
var UPDATE_BATCH_STATUSES = "UPDATE_BATCH_STATUSES";
var CLEAR_LICENSE_EDITING_ID = "CLEAR_LICENSE_EDITING_ID";
var UPDATE_TABLE_LAYOUT = "UPDATE_TABLE_LAYOUT";
var UPDATE_USERS = "UPDATE_USERS";
var UPDATE_DRAWERS = "UPDATE_DRAWERS";
var SET_TOKEN = "SET_TOKEN";
var RESET_GLOBAL_STATE = "RESET_GLOBAL_STATE";
var CLEAR_LICENSE = "CLEAR_LICENSE";
var CLEAR_LOCK_SCREEN_BANNER = "CLEAR_LOCK_SCREEN_BANNER";
var SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN = "SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN";
var SET_IS_WS_ACTIVE = "SET_IS_WS_ACTIVE";
var WS_HEARTBEAT = "WS_HEARTBEAT";
var INITIALIZE_APP_ON_LOCK_SCREEN = "INITIALIZE_APP_ON_LOCK_SCREEN";
var UPDATE_KEYBOARD = "UPDATE_KEYBOARD";
var REMOVE_MASTER_DATA = "REMOVE_MASTER_DATA";
var SET_LATEST_PAYMENT_INFORMATION = "SET_LATEST_PAYMENT_INFORMATION";
var EToastTypes = /* @__PURE__ */ ((EToastTypes2) => {
  EToastTypes2["SUCCESS"] = "success";
  EToastTypes2["ERROR"] = "error";
  EToastTypes2["INFO"] = "info";
  EToastTypes2["WARNING"] = "warning";
  return EToastTypes2;
})(EToastTypes || {});
var RefreshToastVariant = /* @__PURE__ */ ((RefreshToastVariant2) => {
  RefreshToastVariant2["MENU"] = "MENU";
  RefreshToastVariant2["SETTINGS"] = "SETTINGS";
  RefreshToastVariant2["REPORTS"] = "REPORTS";
  return RefreshToastVariant2;
})(RefreshToastVariant || {});
var EPopoverId = /* @__PURE__ */ ((EPopoverId2) => {
  EPopoverId2["NONE"] = "NONE";
  EPopoverId2["NAVIGATION_CUSTOM_QUANTITY"] = "NAVIGATION_CUSTOM_QUANTITY";
  EPopoverId2["TICKET_ELEMENT_QUANTITY"] = "TICKET_ELEMENT_QUANTITY";
  EPopoverId2["TICKET_ELEMENT_SEAT_QUANTITY"] = "TICKET_ELEMENT_SEAT_QUANTITY";
  EPopoverId2["AUDIT_LOG_DATE_POPOVER"] = "AUDIT_LOG_DATE_POPOVER";
  EPopoverId2["AUDIT_LOG_TIME_POPOVER"] = "AUDIT_LOG_TIME_POPOVER";
  EPopoverId2["TIME_BASED_COPY_RULES_POPOVER"] = "TIME_BASED_COPY_RULES_POPOVER";
  EPopoverId2["VIEW_ALL_ORDERS_FILTERS_POPOVER"] = "VIEW_ALL_ORDERS_FILTERS_POPOVER";
  EPopoverId2["PRINTER_CENTER"] = "PRINTER_CENTER";
  EPopoverId2["SEND_ITEMS"] = "SEND_ITEMS";
  EPopoverId2["SEND_ITEMS_STAY"] = "SEND_ITEMS_STAY";
  EPopoverId2["OPTIONS"] = "OPTIONS";
  EPopoverId2["PRINTER_RULES_DAYS_OF_WEEK"] = "PRINTER_RULES_DAYS_OF_WEEK";
  EPopoverId2["HOURS_OF_OPERATION_COPY_RULES"] = "HOURS_OF_OPERATION_COPY_RULES";
  EPopoverId2["CUSTOM_QUANTITY"] = "CUSTOM_QUANTITY";
  EPopoverId2["EMPLOYEES_FILTERS"] = "EMPLOYEES_FILTERS";
  return EPopoverId2;
})(EPopoverId || {});
var EPopoverPosition = /* @__PURE__ */ ((EPopoverPosition2) => {
  EPopoverPosition2["TOP_CENTER"] = "top-center";
  EPopoverPosition2["BOTTOM_RIGHT"] = "bottom-right";
  EPopoverPosition2["BOTTOM_LEFT"] = "bottom-left";
  EPopoverPosition2["BOTTOM_CENTER"] = "bottom-center";
  EPopoverPosition2["RIGHT"] = "right";
  EPopoverPosition2["LEFT"] = "left";
  return EPopoverPosition2;
})(EPopoverPosition || {});
var EPopoverOptionsId = /* @__PURE__ */ ((EPopoverOptionsId2) => {
  EPopoverOptionsId2["NONE"] = "NONE";
  EPopoverOptionsId2["OPEN_TABS_CARD"] = "OPEN_TABS_CARD";
  return EPopoverOptionsId2;
})(EPopoverOptionsId || {});
var ConfirmationTypes = /* @__PURE__ */ ((ConfirmationTypes2) => {
  ConfirmationTypes2["info"] = "info";
  ConfirmationTypes2["delete"] = "delete";
  ConfirmationTypes2["deleteMultiple"] = "deleteMultiple";
  ConfirmationTypes2["inactiveMultiple"] = "inactiveMultiple";
  ConfirmationTypes2["create"] = "create";
  ConfirmationTypes2["diff"] = "diff";
  ConfirmationTypes2["settingsDiff"] = "settingsDiff";
  ConfirmationTypes2["customersDiff"] = "customersDiff";
  ConfirmationTypes2["reportsDiff"] = "reportsDiff";
  ConfirmationTypes2["warning"] = "warning";
  ConfirmationTypes2["error"] = "error";
  ConfirmationTypes2["orange"] = "orange";
  ConfirmationTypes2["validation"] = "validation";
  ConfirmationTypes2["validationDiscard"] = "validationDiscard";
  ConfirmationTypes2["refresh"] = "refresh";
  ConfirmationTypes2["locationSelection"] = "locationSelection";
  ConfirmationTypes2["locationSettingsSelection"] = "locationSettingsSelection";
  ConfirmationTypes2["locationReportsSelection"] = "locationReportsSelection";
  ConfirmationTypes2["unassociate"] = "unassociate";
  ConfirmationTypes2["permissionDenied"] = "permissionDenied";
  ConfirmationTypes2["settingsValidation"] = "settingsValidation";
  ConfirmationTypes2["settingsValidationDiscard"] = "settingsValidationDiscard";
  ConfirmationTypes2["prepStations"] = "prepStations";
  ConfirmationTypes2["reprintTicketElement"] = "reprintTicketElement";
  ConfirmationTypes2["prepStationsReprint"] = "prepStationsReprint";
  ConfirmationTypes2["tableOptions"] = "tableOptions";
  ConfirmationTypes2["transferOrderOwner"] = "transferOrderOwner";
  ConfirmationTypes2["eightySixed"] = "eightySixed";
  ConfirmationTypes2["drawerActions"] = "drawerActions";
  ConfirmationTypes2["drawerSelection"] = "drawerSelection";
  ConfirmationTypes2["itemDetailsInChecks"] = "itemDetailsInChecks";
  ConfirmationTypes2["VAOItemOptions"] = "VAOItemOptions";
  ConfirmationTypes2["AddOrEditTip"] = "AddOrEditTip";
  ConfirmationTypes2["pickDrawer"] = "pickDrawer";
  ConfirmationTypes2["pickPrinter"] = "pickPrinter";
  ConfirmationTypes2["pickTerminal"] = "pickTerminal";
  ConfirmationTypes2["changeDue"] = "changeDue";
  ConfirmationTypes2["voidReasonSelection"] = "voidReasonSelection";
  ConfirmationTypes2["customerValidationDiscard"] = "customerValidationDiscard";
  ConfirmationTypes2["customerValidation"] = "customerValidation";
  ConfirmationTypes2["multipleItems"] = "multipleItems";
  ConfirmationTypes2["orderPicker"] = "orderPicker";
  ConfirmationTypes2["GiftCardInsufficientBalance"] = "GiftCardInsufficientBalance";
  ConfirmationTypes2["similarItems"] = "similarItems";
  ConfirmationTypes2["courseSelection"] = "courseSelection";
  ConfirmationTypes2["userInactivity"] = "userInactivity";
  return ConfirmationTypes2;
})(ConfirmationTypes || {});
var NetworkStatuses = /* @__PURE__ */ ((NetworkStatuses2) => {
  NetworkStatuses2["ONLINE"] = "online";
  NetworkStatuses2["OFFLINE"] = "offline";
  NetworkStatuses2["DEFAULT"] = "default";
  return NetworkStatuses2;
})(NetworkStatuses || {});
var PRINT_RECEIPT_TOAST = "PRINT_RECEIPT_TOAST";
var SEND_ITEMS_TO_KITCHEN_TOAST = "SEND_ITEMS_TO_KITCHEN_TOAST";
var SEND_ITEMS_TO_KITCHEN_AND_CLOSE_TOAST = "SEND_ITEMS_TO_KITCHEN_AND_CLOSE_TOAST";
var REMOVE_HELD_ITEMS_TOAST = "REMOVE_HELD_ITEMS_TOAST";
var REMOVE_HELD_ITEMS_TOAST_AND_CLOSE = "REMOVE_HELD_ITEMS_TOAST_AND_CLOSE";
var SEND_AND_REMOVE_HELD_ITEMS_TOAST = "SEND_ITEMS_AND_REMOVE_HELD_ITEMS_TOAST";

export { CLEAR_FIRE_PRINTING_ERROR, CLEAR_LICENSE, CLEAR_LICENSE_EDITING_ID, CLEAR_LOCK_SCREEN_BANNER, CONFIRMED_PRINT_JOBS, ConfirmationTypes, EPopoverId, EPopoverOptionsId, EPopoverPosition, EToastTypes, FIRE_PRINTING_ERROR, INITIALIZE_APP_ON_LOCK_SCREEN, KITCHEN_PRINTING_ERROR, KITCHEN_PRINTING_ERROR_WS, NetworkStatuses, PRINT_RECEIPT_TOAST, REMOVE_HELD_ITEMS_TOAST, REMOVE_HELD_ITEMS_TOAST_AND_CLOSE, REMOVE_MASTER_DATA, REMOVE_TOAST_ELEMENT, RESET_GLOBAL_STATE, RefreshToastVariant, SEND_AND_REMOVE_HELD_ITEMS_TOAST, SEND_ITEMS_TO_KITCHEN_AND_CLOSE_TOAST, SEND_ITEMS_TO_KITCHEN_TOAST, SET_CURRENT_DEVICE_USING_LICENSE, SET_HIDE_REFRESH_TOAST, SET_HIDE_TOAST, SET_IS_CLOCK_IN_SUGGESTION_MODAL_OPEN, SET_IS_LOADING, SET_IS_LOADING_MODAL, SET_IS_LOADING_MORE, SET_IS_WS_ACTIVE, SET_LATEST_PAYMENT_INFORMATION, SET_LOCK_SCREEN_BANNER, SET_MESSAGE_ID, SET_NETWORK_STATUS, SET_PULLING_DATA, SET_SELECTED_NETWORK, SET_SHOW_CONFIRMATION_MODAL_QUEUE, SET_SHOW_CONFORMATION_MODAL, SET_SHOW_REFRESH_TOAST, SET_SHOW_SETTINGS_REFRESH_TOAST, SET_SHOW_TOAST, SET_TOKEN, TRANSFERRED_PRINT_JOBS, UPDATE_BATCH_STATUSES, UPDATE_DRAWERS, UPDATE_KEYBOARD, UPDATE_POPOVER, UPDATE_PRINTER_STATUS, UPDATE_TABLE_LAYOUT, UPDATE_USERS, WS_HEARTBEAT };
